<template>
  <div class="modal offer-modal skin-modal">
    <div class="overlay" @click="closeSaleSkinModal"></div>
    <div class="wrapper">
      <img
        class="close"
        @click="closeSaleSkinModal"
        src="./../assets/close.svg"
      />
      <div class="container">
        <form>
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="title title-24">
                <b>Sell your skin</b>
              </div>
              <div class="form-fields-wrapper">
                <div class="input-container">
                  <div class="desc"><span class="red">*</span> Skin name:</div>
                  <input type="text" placeholder="Skin name" v-model="title" />
                </div>

                <div class="input-container">
                  <div class="desc">
                    <span class="red">*</span> Desired price:
                  </div>
                  <input
                    type="text"
                    placeholder="Enter price"
                    v-model="price"
                    @input="allowOnlyNumbers"
                  />
                </div>

                <div class="input-container">
                  <div class="desc"><span class="red">*</span>Quality:</div>
                  <Select2
                    class="select2 single"
                    v-model="quality"
                    :options="qualityOptions"
                    placeholder="Quality"
                    @select="handleQualitySelect($event)"
                  />
                </div>

                <div class="input-container">
                  <div class="desc">Steam inventory link to skin:</div>
                  <input
                    type="text"
                    placeholder="Steam inventory link to skin"
                    v-model="item_url"
                  />
                </div>

                <transition name="slide">
                  <div v-if="$parent.error" class="error-desc desc red">
                    {{ $parent.error }}
                  </div>
                </transition>
                <div class="buttons">
                  <button
                    type="button"
                    class="button orange-btn"
                    @click="closeSaleSkinModal"
                  >
                    <span>Cancel</span>
                  </button>
                  <button
                    type="button"
                    :class="['button', { disabled: !isValid }]"
                    @click="createOffer"
                  >
                    <span>Create offer</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Select2 from "vue3-select2-component";

export default {
  name: "SaleSkinModal",
  props: [],
  components: {
    Select2,
  },
  data() {
    return {
      title: "",
      quality: "",
      price: "",
      item_url: "",
      qualityOptions: [
        { id: "Field-Tested", text: "Field-Tested" },
        { id: "Minimal Wear", text: "Minimal Wear" },
        { id: "Battle-Scarred", text: "Battle-Scarred" },
        { id: "Well-Worn", text: "Well-Worn" },
        { id: "Factory New", text: "Factory New" },
        { id: "Not Painted", text: "Not Painted" },
      ],
    };
  },
  computed: {
    isValid() {
      return !!(this.title && this.quality && this.price);
    },
  },
  methods: {
    allowOnlyNumbers() {
      this.price = this.price.replace(/[^0-9.,]/g, "");

      const parts = this.price.split(/[.,]/);
      const integerPart = parts[0];
      let decimalPart = parts[1];

      if (decimalPart !== undefined && decimalPart.length > 2) {
        decimalPart = decimalPart.slice(0, 2);
      }

      this.price =
        decimalPart !== undefined
          ? `${integerPart}.${decimalPart}`
          : integerPart;
    },
    closeSaleSkinModal() {
      this.$emit("closeSaleSkinModal");
    },
    createOffer() {
      if (!this.isValid) return;

      const data = {
        title: this.title,
        quality: this.quality,
        price: this.price,
        item_url: this.item_url,
        currency: this.$parent.currency,
      };

      this.$emit("createOffer", data);
    },
    handleQualitySelect(event) {
      this.quality = event.text;
    },
  },
};
</script>

<style scoped>
::v-deep .select2-container {
  width: 100% !important;
}

::v-deep .select2-container .select2-selection.select2-selection--single {
  height: 49px;
  border-bottom: 3px solid #495158;
}

::v-deep .select2-container #select2--container {
  line-height: 49px;
}

.buttons {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 8px;
  margin-top: 12px;
}

.input-container .desc {
  margin-bottom: 8px;
}
</style>
